module.exports = InternalShared('InternalShared/Dialog/FileUploader');